import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MemoryManagementService {
  private timeouts: Set<number> = new Set();
  private intervals: Set<number> = new Set();
  private eventListeners: Array<{ element: EventTarget; event: string; listener: EventListener }> = [];

  // Track and manage timeouts
  trackTimeout(timeoutId: number): number {
    this.timeouts.add(timeoutId);
    return timeoutId;
  }

  // Track and manage intervals
  trackInterval(intervalId: number): number {
    this.intervals.add(intervalId);
    return intervalId;
  }

  // Track event listeners
  trackEventListener(element: EventTarget, event: string, listener: EventListener): void {
    this.eventListeners.push({ element, event, listener });
  }

  // Clear all tracked timeouts
  clearAllTimeouts(): void {
    this.timeouts.forEach(id => clearTimeout(id));
    this.timeouts.clear();
  }

  // Clear all tracked intervals
  clearAllIntervals(): void {
    this.intervals.forEach(id => clearInterval(id));
    this.intervals.clear();
  }

  // Remove all tracked event listeners
  removeAllEventListeners(): void {
    this.eventListeners.forEach(({ element, event, listener }) => {
      element.removeEventListener(event, listener);
    });
    this.eventListeners = [];
  }

  // Clean up all tracked resources
  cleanup(): void {
    this.clearAllTimeouts();
    this.clearAllIntervals();
    this.removeAllEventListeners();
  }

  // Clear localStorage periodically to prevent accumulation
  clearOldLocalStorage(): void {
    const keys = Object.keys(localStorage);
    const now = Date.now();
    const maxAge = 7 * 24 * 60 * 60 * 1000; // 7 days

    keys.forEach(key => {
      try {
        const item = localStorage.getItem(key);
        if (item) {
          const parsed = JSON.parse(item);
          if (parsed.timestamp && (now - parsed.timestamp) > maxAge) {
            localStorage.removeItem(key);
          }
        }
      } catch (e) {
        // If parsing fails, remove the item
        localStorage.removeItem(key);
      }
    });
  }
}
